module.exports = __webpack_public_path__ + "static/img/IMG_20160224_125434.60ec887f.jpg";